import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { IconButton, Stack } from "@mui/material";
import type { Widgets } from "../../../../../api/types/dashboardsTypes";
import EditableTitle from "../../../../common/EditableTitle";
import { useDashboardContext } from "../../contexts/DashboardContext";

const Header = ({ widget }: { widget: Widgets }) => {
  const { setSelectedWidgetId, updateWidget } = useDashboardContext();

  const onBackClick = () => {
    setSelectedWidgetId(undefined);
  };

  const onTitleChanged = (title: string) => {
    updateWidget(widget.widgetId, { nameUserInput: title });
  };

  return (
    <Stack direction="row" sx={{ alignItems: "center", gap: 1, height: 51, px: 2 }}>
      <IconButton onClick={onBackClick}>
        <ArrowBackRoundedIcon />
      </IconButton>
      <EditableTitle
        title={widget.nameUserInput}
        tooltip="Rename Widget"
        onTitleChanged={onTitleChanged}
        placeholder="Enter Widget Name"
        titleProps={{ noWrap: true }}
      />
    </Stack>
  );
};

export default Header;
